export default __webpack_public_path__ + "scripts/resource/65fe4599faf6a95918a3736a5ec63c3b.svg";